import React, { useEffect, useState } from "react";
import "./VideoPlayer.css";

const Mp4Player = ({ url, onClose }) => {
    var [urlState, setUrlState] = useState("https://platovideo.blob.core.windows.net/manim/" + url);
    var [isExpanded, setIsExpanded] = useState(false);
    useEffect(() =>  {
        console.log(url + " #url");
        setUrlState("");
        var newUrlState = "https://platovideo.blob.core.windows.net/manim/" + url;
        console.log(newUrlState + " #Modifiedurl");
        setUrlState(newUrlState);
        setIsExpanded(true);
    }, [url]);

    const handleVideoEnd = () => {
        setIsExpanded(false);
        if (onClose) onClose();
      };
      
    return ( urlState &&
        <div className={`theater-container ${isExpanded ? "theater-mode" : ""}`}>
        {/* Screening lights on top */}
        <div className="screening-icon">
            <img
            src="/film.svg"
            alt="Theater Screening Light"
            className="screening-light"
            />
        </div>
        {/* Video frame */}
        <video key={urlState} width="100%" height="100%" controls autoPlay onEnded={handleVideoEnd}>
            <source src={urlState} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
        </div>
    );
};

export default Mp4Player;